import FieldPresenter from './recordm.presenter.instance.field.js';

import utils from '@cob/ui-genesis/cob.utils.js';

const DuplicateFieldsPresenter = function(core, internal, view, instance, field, parent, opts, ignoreDefaults, clipboard, callbacks) {

    var _duplicatePs = [],
        _originalP;

    const _addDuplicateField = function(_event, duplicateField) {
        var newFieldOpts = utils.clone(opts),
            originalField = _originalP.getField(),
            newFieldP ;

        newFieldOpts.isNewDuplicate = (duplicateField.id <= 0);
        newFieldOpts.placeholders = originalField.placeholders;

        newFieldP = new FieldPresenter(
            core, internal, instance, duplicateField, parent, newFieldOpts, ignoreDefaults, clipboard, {
                fieldDropped: _fieldDropped
            }
        );

        const afterWhom = _duplicatePs[_duplicatePs.length - 1];

        _duplicatePs.push(newFieldP);

        if (afterWhom) {
            view.addChildFieldAfter(newFieldP, afterWhom);

        } else {
            view.addChildFieldAfter(newFieldP, _originalP);
        }

        internal.subscribe("field-collection-decrement-" + duplicateField.id, _removeDuplicateField);

        if (typeof view.getValue === 'function') {
            internal.publish('field-value-change-' + parent.field.id, view.getValue());
        }

        newFieldP.initDuplicate();
    };

    const _removeDuplicateField = function(event, duplicateFieldId) {
        var collLength = _duplicatePs.length,
            idx;

        for (let i = 0; i < collLength; i++) {
            if (_duplicatePs[i].getId() === duplicateFieldId) {
                idx = i;
            }
        }

        _duplicatePs[idx].destroy();

        _duplicatePs = _duplicatePs.slice(0, idx).concat(_duplicatePs.slice(idx + 1));
    };

    const _fieldDropped = function(droppedFieldId, targetFieldId){
        const droppedFieldIdx = _duplicatePs.findIndex((p) => p.getId() === droppedFieldId)

        // remover
        let dropped;
        if(droppedFieldIdx == -1){
            // é o _originalP, promovemos o primeiro duplicado a original
            dropped = _originalP;
            _originalP = _duplicatePs.splice(0, 1)[0];
            //
            // trocamos os duplicates e recalculamos os botões que se mostram
            dropped.disable();
            dropped.getField().duplicate = true;
            dropped.enable()
            _originalP.disable();
            _originalP.getField().duplicate = false;
            _originalP.enable();

        } else {
            dropped = _duplicatePs.splice(droppedFieldIdx, 1)[0];

        }
        dropped.content().detach();

        const targetFieldIdx = _duplicatePs.findIndex((p) => p.getId() === targetFieldId)

        // adicionar
        if(targetFieldIdx == -1){
            // é o _originalP, portanto adicionamos no topo
            _duplicatePs.splice(0, 0, dropped);
            view.addChildFieldAfter( _duplicatePs[0], _originalP);

        } else {
            _duplicatePs.splice(targetFieldIdx + 1, 0, dropped);
            view.addChildFieldAfter(dropped, _duplicatePs[targetFieldIdx]);
        }

        // window.console.debug('JN', [_originalP].concat(_duplicatePs).map((p) => `${p.getValue()}[${p.getField().duplicate ? 'x':''}]`))
    }

    const _init = function() {
        _originalP = new FieldPresenter(
            core, internal, instance, field, parent, opts, ignoreDefaults, clipboard, {
                fieldDropped: _fieldDropped,
                ...callbacks
            }
        );

        view.addChildField(_originalP);

        internal.subscribe("field-collection-decrement-" + field.id, _removeDuplicateField);

        //Distinguish between child fields and root fields
        if (parent && parent.field && parent.field.fieldDefinition) {
            internal.subscribe("field-collection-increment-" + parent.field.id + "-" + field.fieldDefinition.id, _addDuplicateField);
        } else {
            internal.subscribe("instance-root-field-collection-increment-" + field.fieldDefinition.id, _addDuplicateField);
        }
    };

    _init();

    return{
        init: _init,
        // called only when it's a new duplicate of an existing field
        // to do what is done normally as a response to 'instance-ready-internal'
        // we only need to pass through to the fieldPs themselves
        initDuplicate: function(){
            _originalP.initDuplicate();
            _duplicatePs.forEach((p) => p.initDuplicate());
        },
        getId: function(){
            return field.id;
        },
        getField: function(){
            return field;
        },
        addDuplicate: _addDuplicateField,
        removeDuplicate: _removeDuplicateField,
        getFieldPs: function(){
           return [_originalP].concat(_duplicatePs);
        },
        fillModel: function(field_, withLocalIds) {
            if (field_.fields) {
                field_.fields.push(_originalP.getModel(withLocalIds));
                _duplicatePs.forEach(function(el) {
                    field_.fields.push(el.getModel(withLocalIds));
                });
            }
        },
        isVisible: function() {
            return _originalP.isVisible();
        },
        isNewlyVisible: function() {
            return _originalP.isNewlyVisible();
        },
        validate: function() {
            var allOk = true;

            allOk = _originalP.validate() && allOk;

            _duplicatePs.forEach(function(fieldP) {
                allOk = fieldP.validate() && allOk;
            });

            return allOk;
        },
        fillClones: function(fieldClone) {
            if (fieldClone.fields) {
                fieldClone.fields.push(_originalP.getClone(false, fieldClone.id));
            }
        },
        presentErrors: function(errors) {
            _originalP.presentErrors(errors);

            _duplicatePs.forEach(function(fieldP) {
                fieldP.presentErrors(errors);
            });
        },
        destroy: function(){
            _originalP.destroy();

            internal.unsubscribe("field-collection-decrement-" + field.id);

            if (parent && parent.field && parent.field.fieldDefinition) {
                internal.unsubscribe("field-collection-increment-" + parent.field.id + "-" + field.fieldDefinition.id);
            } else {
                internal.unsubscribe("instance-root-field-collection-increment-" + field.fieldDefinition.id);
            }
            _duplicatePs.forEach((dup) => dup.destroy());
        }
    }
};

export default DuplicateFieldsPresenter;
